import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationComponent } from '../../notification/notification.component';
import { DialogComponent } from '../../dialog/dialog.component';

@Component({
  selector: 'wl-workspace',
  templateUrl: 'workspace.component.html',
  styleUrls: ['workspace.component.css'],
    standalone: false
})
export class WorkspaceComponent implements OnInit {
  //public _router: Router;

  //public breadCrumbPath: string = "";

  //public constructor(router: Router) {

  //    this._router = router;

  //}

  ngOnInit() {}
}
